import { render, staticRenderFns } from "./process-list.vue?vue&type=template&id=6c598ca1&scoped=true"
import script from "./process-list.vue?vue&type=script&lang=js"
export * from "./process-list.vue?vue&type=script&lang=js"
import style0 from "./process-list.vue?vue&type=style&index=0&id=6c598ca1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c598ca1",
  null
  
)

export default component.exports